module.exports = __webpack_public_path__ + "img/logo.3aff765d.png";